import request from 'meinian-package/src/utils/request'

interface IDetailInfo{
    itemInfoDTOList: any[],
    itemIdList: any[],
    inspirationId:number,
    entityId: string,
    [other:string]: any,
}

export default async function getInfo(inspirationId:number, entityId:string) {
  try {
    const res: IDetailInfo = await request.get('/zhikuan/image-bus/get-style-detail', { params: { inspirationId, entityId } })
    const itemInfoDTOList = res?.itemInfoDTOList
    const goodList = []
    if (itemInfoDTOList?.length > 0) {
      for (let i = 0; i < itemInfoDTOList.length; i++) {
        goodList.push({
          itemId: res?.itemIdList[i],
          title: itemInfoDTOList[i].itemTitle,
          cprice: itemInfoDTOList[i].price,
          picUrl: itemInfoDTOList[i].mainUrl,
          sale30day: itemInfoDTOList[i].saleMonthly,
          ...itemInfoDTOList[i]
        })
      }
    }
    return {
      ...res,
      goods: goodList?.length > 0 ? goodList : null
    }
  } catch (error) {
    console.error(error)
  }
}
